import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import DropDown from "./DropDown";
import { useNavigationContext } from "../../../context/navigation/navigationContext";

const AsideInner = ({ onClose }) => (
  <>
    <div className="flex items-center justify-between px-4 py-4">
      <div className="flex items-center gap-2">
        <span aria-hidden className="inline-block h-2.5 w-2.5 rounded-full bg-gradient-to-tr from-emerald-500 via-amber-500 to-purple-500" />
        <div className="flex flex-col">
          <h1 className="text-[13px] font-semibold tracking-tight text-gray-900">DoseeAfrica Admin</h1>
          <span className="text-[11px] text-gray-500">Navigation</span>
        </div>
      </div>
      <button
        type="button"
        aria-label="Close sidebar"
        onClick={onClose}
        className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 xl:hidden"
      >
        <FaTimes className="h-4 w-4" />
      </button>
    </div>

    <div className="h-[3px] w-full bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500/80" />

    <div
      className="custom-scroll flex-1 overflow-y-auto overflow-x-hidden px-3 py-4 pr-2"
      style={{ scrollbarGutter: "stable both-edges" }}
    >
      <DropDown />
    </div>

    <div className="border-t border-gray-100 px-4 py-3">
      <p className="text-[11px] text-gray-500">Tip: Use the search to quickly find a section.</p>
    </div>

    <style>{`
      .custom-scroll { scrollbar-width: thin; scrollbar-color: rgba(100,116,139,0.35) transparent; }
      .custom-scroll::-webkit-scrollbar { width: 2px; }
      .custom-scroll::-webkit-scrollbar-track { background: transparent; }
      .custom-scroll::-webkit-scrollbar-thumb {
        background-color: rgba(100,116,139,0.35);
        border-radius: 9999px;
        border: 2px solid transparent;
        background-clip: padding-box;
      }
      .custom-scroll:hover::-webkit-scrollbar-thumb { background-color: rgba(100,116,139,0.5); }
    `}</style>
  </>
);

const MobileLayer = ({ children }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? createPortal(children, document.body) : null;
};

const SideBar = () => {
  const { showSideBar, setShowSideBar } = useNavigationContext();

  useEffect(() => {
    if (!showSideBar) return;
    const prev = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = prev;
    };
  }, [showSideBar]);

  return (
    <>
      <aside
        className={[
          "hidden xl:flex xl:static xl:inset-auto xl:h-screen xl:w-[340px] flex-col",
          "bg-white border-r border-gray-200 shadow-none",
          "isolate",
        ].join(" ")}
        aria-label="Sidebar Navigation"
      >
        <AsideInner onClose={() => setShowSideBar(false)} />
      </aside>

      <MobileLayer>
        {showSideBar ? (
          <div
            onClick={() => setShowSideBar(false)}
            className="fixed inset-0 z-[2147483647] bg-black/40 backdrop-blur-[2px] transition-opacity xl:hidden"
            aria-hidden="true"
          />
        ) : null}

        <aside
          role="dialog"
          aria-modal={showSideBar ? "true" : "false"}
          className={[
            "fixed inset-y-0 left-0 xl:hidden",
            "z-[2147483647] isolate",
            "flex h-screen w-[300px] flex-col bg-white border-r border-gray-200 shadow-xl",
            "transition-transform duration-300 ease-out",
            showSideBar ? "translate-x-0" : "-translate-x-full",
          ].join(" ")}
          aria-label="Sidebar Navigation"
        >
          <AsideInner onClose={() => setShowSideBar(false)} />
        </aside>
      </MobileLayer>
    </>
  );
};

export default SideBar;
